export default {"src":"/_next/static/media/_editor.3ea3883c.svg","height":24,"width":24};